<template>
    <div class="photos" :class="[justifyContentClass]">
        <template v-if="photos.length">
            <div v-for="(photo, index) in photos" :key="index" class="photo" :class="[cursorClass]">
                <template v-if="photo">
                    <img width="auto" height="100px" :src="photo.url" @click="openGallery(index)" :alt="photo.name" />
                    <div v-if="editable" class="remove-icon" @click="checkRemovePhoto(index)">
                        <font-awesome-icon :icon="['far', 'times-circle']" />
                    </div>
                </template>
            </div>
        </template>

        <div v-if="editable && showEditBtn" class="upload-btn" @click="prepareFile">
            <font-awesome-icon :icon="['fas', 'camera']" />
        </div>
        <div v-for="index2 in maxPhotos" :key="index2 + 'dummy'" class="photo"></div>
        <LightBox
            ref="lightbox"
            :media="lightBoxPhotos"
            :showThumbs="false"
            :show-light-box="false"
            v-if="readOnly && !editable"
        />
        <input
            type="file"
            ref="photosInput"
            name="photosInput"
            id="photosInput"
            @change="onFileChange"
            accept="image/*"
            :multiple="maxPhotos > 1"
        />
    </div>
</template>

<script>
// usando o lightBox
import 'vue-image-lightbox/dist/vue-image-lightbox.min.css';
import LightBox from 'vue-image-lightbox';

import { mapActions } from 'vuex';

export default {
    props: {
        maxPhotos: {
            type: Number,
            default: 1,
        },
        photos: {
            type: [Object, Array],
            default: () => {
                return {};
            },
        },
        readOnly: {
            type: Boolean,
            return: false,
        },
        editable: {
            type: Boolean,
            return: false,
        },
        maxSizeValidation: {
            // o valor tem que ser em byte
            type: Number,
            default: 10485760,
        },
    },
    components: {
        LightBox,
    },
    data() {
        return {
            isMobile: false,
            isMedium: false,
            isFileValid: true,
        };
    },
    computed: {
        lightBoxPhotos() {
            return this.photos.map((element) => {
                return { thumb: element.url, src: element.url };
            });
        },
        cursorClass() {
            return this.readOnly || this.editable ? 'cursor-pointer' : '';
        },
        justifyContentClass() {
            // lógica das classes flex para cada resolução e quantidade de fotos
            if (this.isMobile) {
                if (this.photos.length >= 2) {
                    return 'justify-content-between';
                } else {
                    return 'justify-content-start';
                }
            } else if (this.isMedium) {
                if (this.photos.length >= 4) {
                    return 'justify-content-between';
                } else {
                    return 'justify-content-start';
                }
            } else {
                if (this.photos.length >= 5) {
                    return 'justify-content-between';
                } else {
                    return 'justify-content-start';
                }
            }
        },
        showEditBtn() {
            // fazer a lógica de quando tiver maxPhotos > 1 ser maxPhotos +1 senão maxPhotos
            if (this.photos.length == 1) {
                return this.maxPhotos + 1 > this.photos.length;
            } else {
                return this.maxPhotos > this.photos.length;
            }
        },
    },
    methods: {
        ...mapActions('sweetalert2', ['showToast']),
        openGallery(index) {
            if (this.readOnly && !this.editable) this.$refs.lightbox.showImage(index);
        },
        prepareFile() {
            this.$refs.photosInput.click();
        },
        async onFileChange(e) {
            if (e) {
                if (e.target.files.length > this.maxPhotos - this.photos.length && this.maxPhotos != 1) {
                    this.showToast({
                        title: `Você atingiu o maximo de ${this.maxPhotos} fotos.`,
                        icon: 'error',
                    });
                } else {
                    this.isFileValid = true;
                    await this.validateAttachmentSize(e.target.files);
                    if (this.isFileValid) {
                        this.$emit('fileChoose', e);
                    } else {
                        this.showToast({
                            title: `As imagens podem ter no máximo ${
                                this.maxSizeValidation / 1024 / 1024
                            }MB de tamanho.`,
                            icon: 'error',
                        });
                    }
                }
            }
        },
        async validateAttachmentSize(files) {
            for (let i = 0; i < files.length; i++) {
                if (files[i] > this.maxSizeValidation) {
                    this.isFileValid = false;
                }
            }
        },
        checkRemovePhoto(index) {
            this.$swal({
                title: 'Remover Arquivo',
                text: 'Você tem certeza de que quer remover esse arquivo?',
                icon: 'warning',
                reverseButtons: true,
                showConfirmButton: true,
                showCancelButton: true,
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não',
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$emit('removePhoto', index);
                }
            });
        },
    },
    mounted() {
        const vue = this;
        window.addEventListener('resize', () => {
            vue.isMobile = window.innerWidth <= 768;
            vue.isMedium = window.innerWidth <= 1024;
        });
        vue.isMobile = window.innerWidth <= 768;
        vue.isMedium = window.innerWidth <= 1024;
    },
};
</script>

<style lang="scss" scoped>
#photosInput {
    display: none;
}
.photos {
    display: flex;
    flex-wrap: wrap;
    ::v-deep button.vue-lb-arrow {
        background-color: transparent;
    }
    &.justify-content-between {
        justify-content: space-between;
    }
    &.justify-content-start {
        justify-content: flex-start;
    }
    .cursor-pointer {
        cursor: pointer;
    }
    .upload-btn {
        width: 18%;
        height: 100px;
        background-color: #dbdbdb;
        display: flex;
        justify-content: center;
        align-items: center;
        color: white;
        font-size: 25px;
        border-radius: 5px;
        margin-right: 8px;
        margin-bottom: 8px;
        cursor: pointer;
        @media screen and (min-width: 1025px) {
            &:nth-child(5n) {
                margin-right: 0;
            }
        }
        // tablet
        @media screen and (max-width: 1024px) {
            width: 23%;
            &:nth-child(4n) {
                margin-right: 0;
            }
        }
        // mobile
        @media screen and (max-width: 767px) {
            width: 48%;
            &:nth-child(2n) {
                margin-right: 0;
            }
        }
    }
    .photo {
        width: 18%;
        height: 18%;
        margin-right: 8px;
        margin-bottom: 8px;
        position: relative;
        // telas grandes
        @media screen and (min-width: 1025px) {
            &:nth-child(5n) {
                margin-right: 0;
            }
        }
        // tablet
        @media screen and (max-width: 1024px) {
            width: 23%;
            height: 23%;
            &:nth-child(4n) {
                margin-right: 0;
            }
        }
        // mobile
        @media screen and (max-width: 767px) {
            width: 48%;
            height: 48%;
            &:nth-child(2n) {
                margin-right: 0;
            }
        }
        img {
            background-color: #ccc;
            width: 100%;
            object-fit: cover;
            border-radius: 5px;
            border: 1px solid #dbdbdb;
        }
        .remove-icon {
            position: absolute;
            top: -5px;
            right: -5px;
            font-size: 20px;
            background-color: white;
            line-height: 0px;
            border-radius: 100%;
            color: #ff0000;
        }
    }
}
</style>